import * as React from "react";
import { forwardRef } from "react";
const SvgTextFormat = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2 18H18M4 14L10 2L16 14M6 10H14", stroke: "#2C2D32", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgTextFormat);
export default ForwardRef;
